/* 
  This is an email notification service for biocore
*/
import { Plugin } from "plugin";
import later from "later";
import DOMPurify from "dompurify";
import SMTPClient from "smtpclient";

const DEFAULT_SETTINGS = {
  from: "info@jfermi.com"  
};

class EmailService extends Plugin {
  constructor(...args) {
    super(...args);

    if (!localStorage.getItem("email_settings"))
      localStorage.setItem("email_settings", JSON.stringify(DEFAULT_SETTINGS));

    this.addEventListener("fermentationstart", this.fermentationstart_handler.bind(this));
    this.addEventListener("fermentationstop", this.fermentationstop_handler.bind(this));
    this.addEventListener("onauthenticated", this.#onauthenticated_handler.bind(this));

    var settings = JSON.parse(localStorage.getItem("email_settings"));
    if (settings.enableProgressReport)
      this.__startScheduler();
  }
  RM_getEmailSettings() {
    return(JSON.parse(localStorage.getItem("email_settings")));
  }
  RM_setEmailSettings(request, settings) {    
    //if (settings.message)
    //  settings.message = DOMPurify.sanitize(settings.message);
    localStorage.setItem("email_settings", JSON.stringify(settings));    
    
    if (settings.enableProgressReport)
      this.__startScheduler();
    else 
      this.__stopScheduler();    
  }
  __startScheduler() {
    /* if there is a scheduler already running first we stop that */
    if (this.intervalId!==undefined) {
      this.intervalId.clear();        
      delete this.intervalId;
    }

    later.date.localTime();
    /* if there is a schedule we have to start the scheduler */
    var settings = JSON.parse(localStorage.getItem("email_settings"));
    if (settings.schedule) {      
      var sched = later.parse.text(settings.schedule);
      //correct schedule definition
      if (sched.error==-1) {        
        this.intervalId = later.setInterval(this.interval_callback.bind(this), sched);
        console.info("Notification scheduler running. Next occurance: " + later.schedule(sched).next(5, new Date())[0]);
      } else {
        console.warn(`Error in schedule definition at character: ${sched.error}`);
      }      
    }    
  }
  __stopScheduler() {
    /* if there is a scheduler running we stop that */
    if (this.intervalId!==undefined) {
      this.intervalId.clear();        
      delete this.intervalId;
      console.info("Notification scheduler stopped");
    }    
  }
  async interval_callback() {
    var settings = JSON.parse(localStorage.getItem("email_settings"));
    /* we try to send the email based on email_settings */
    try {      
      var smtpClient = new SMTPClient();
      await smtpClient.connect(settings.host, settings.port);
      await smtpClient.authLogin(settings.username, settings.password);
      await smtpClient.send(settings.from, settings.to, settings.message, {
        "From": settings.from,
        "To": settings.to,
        "Subject": "jFermi progress riport",
        "Mime-Version": "1.0",
        "Content-Type": 'text/html; charset="UTF-8"'
      });      
      await smtpClient.close();

      console.log("Progress riport has been sent.");
    } catch(e) {
      console.warn(`Failed to send scheduled email: ${e.message}`);
    }
  }
  async RM_emailTest() {
    SMTPClient.logLevel = 4;
    await this.interval_callback();
    SMTPClient.logLevel = 2;
  }  
  fermentationstart_handler() {
  }  
  fermentationstop_handler() {
  }
  /* when there is a new client we inform it that the service is running */
  /* so it could update its DOM respectively */
  #onauthenticated_handler() {
    clients.notifyAll("RM_addState", "emailservice");
  }
}

/*
time left until next schedule: 
next = later.schedule(mySchedule).next()
timeLeft = moment(next).fromNow()
console.log(timeLeft) // 'in 20 minutes'
*/

export default EmailService;